<template>
  <b-card>
    <div style="font-size: 12px">
      <div class="title">
        <span>Cadastro de Alunos</span>
      </div>
      <div class="rowContainer">
        <span> <b-icon-cloud-fill></b-icon-cloud-fill> Informações Gerais</span>
        <div style="display: flex; justify-content: space-around">
          <div class="leftImg">
            <div>
              <label class="logo" for="input_file">
                <span
                  style="
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <img
                    v-if="!dataStudent.urlFoto && !imgBase64"
                    :class="`${classImg} imageCourse`"
                    :src="notImg"
                  />
                  <img
                    v-else
                    :hidden="!dataStudent.urlFoto && !imgBase64"
                    :class="`${classImg} imageCourse`"
                    :src="
                      imgBase64
                        ? imgBase64
                        : `${dataStudent.urlFoto}?timestamp=${Date.now()}`
                    "
                  />
                </span>
              </label>
              <input type="file" id="input_file" @change="selectImage" />
            </div>
            <span class="user-label-img">
              <b-icon-images></b-icon-images> Selecione a Imagem
            </span>
          </div>
          <div
            class="rowContent"
            style="flex-direction: column; width: 50%; justify-content: center"
          >
            <div class="input-group" style="height: 30px; max-height: 30px">
              <input
                required
                class="input borderInput"
                v-model="dataStudent.name"
              />
              <label class="user-label"> Nome </label>
            </div>
            <div class="input-group" style="height: 30px; max-height: 30px">
              <input
                required
                class="input borderInput"
                v-model="dataStudent.rg"
              />
              <label class="user-label"> RG </label>
            </div>
            <div class="input-group" style="height: 30px; max-height: 30px">
              <input
                required
                class="input borderInput"
                v-model="dataStudent.cpf"
              />
              <label class="user-label"> CPF </label>
            </div>
            <div class="input-group" style="height: 30px; max-height: 30px">
              <input
                type="date"
                class="input borderInput"
                v-model="dataStudent.birthDate"
              />
              <label class="user-label"> Data de Nascimento </label>
            </div>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span>
          <b-icon-cloud-fill></b-icon-cloud-fill> Endereço e Contatos</span
        >
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.address"
            />
            <label class="user-label"> Endereço </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.district"
            />
            <label class="user-label"> Bairro </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.number"
            />
            <label class="user-label"> Numero </label>
          </div>
        </div>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.cep"
            />
            <label class="user-label"> CEP </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.uf"
            />
            <label class="user-label"> UF </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.city"
            />
            <label class="user-label"> Cidade </label>
          </div>
        </div>
        <div class="rowContent">
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.phone"
            />
            <label class="user-label"> Contato </label>
          </div>
          <div class="input-group">
            <input
              required
              class="input borderInput"
              v-model="dataStudent.email"
            />
            <label class="user-label"> Email </label>
          </div>
        </div>
      </div>
      <div class="rowContainer">
        <span>
          <b-icon-person-circle></b-icon-person-circle> Sobre o Aluno</span
        >
        <div class="rowContent">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              bottom: 10px;
              width: 100%;
              position: relative;
              align-items: center;
            "
          >
            <div
              class="text"
              style="color: #666; font-size: 16px; padding-bottom: 10px"
            >
              Onde estudou:
            </div>
            <div class="radio-input">
              <label class="cyberpunk-checkbox-label">
                <input
                  type="checkbox"
                  v-model="dataStudent.isStudentOfOmega"
                  class="cyberpunk-checkbox"
                />
                Aluno Ômega</label
              >
              <label class="cyberpunk-checkbox-label">
                <input
                  type="checkbox"
                  v-model="dataStudent.isOldStudentOfOmega"
                  class="cyberpunk-checkbox"
                />
                Ex-Aluno Ômega</label
              >
              <label class="cyberpunk-checkbox-label">
                <input
                  type="checkbox"
                  v-model="dataStudent.isSchoolPublic"
                  class="cyberpunk-checkbox"
                />
                Escola pública</label
              >
              <label class="cyberpunk-checkbox-label">
                <input
                  type="checkbox"
                  v-model="dataStudent.isResideForaVicosa"
                  class="cyberpunk-checkbox"
                />
                Reside fora de viçosa</label
              >
            </div>
          </div>
        </div>
      </div>
      <span style="font-size: 16px; font-weight: bold; padding-left: 10px"
        >Cursos Inscritos</span
      >
      <div v-for="course in formattedCourses" :key="course.id" class="course">
        <div class="contentCoursesStudent">
          <div style="display: flex; justify-content: space-between">
            <span style="color: #0188c8; font-size: 16px; font-weight: bold">
              {{ course.courseName }}
            </span>
            <span
              style="
                color: #0188c8;
                font-size: 16px;
                font-weight: bold;
                text-transform: uppercase;
              "
            >
              {{ course.status }}
            </span>
          </div>
          <span
            >Pagamento do Material:
            <strong style="font-weight: bold">{{
              course.paymentMaterial
            }}</strong>
          </span>
          <span
            >Pagamento do Curso:
            <strong style="font-weight: bold">{{
              course.paymentCourse
            }}</strong>
          </span>
          <span
            >Situação dos Documentos:
            <strong style="font-weight: bold">{{
              course.documentsApproved.status
            }}</strong>
          </span>
          <span>
            Observação: {{ course.documentsApproved.observation || "Nenhuma" }}
          </span>
          <span>Documentos Aprovados: {{ course.validDocuments }}</span>
        </div>

        <span
          style="
            display: flex;
            font-size: 16px;
            font-weight: bold;
            padding-left: 20px;
            border-bottom: 1px solid #cdcdcd;
            width: 100%;
          "
          >Responsável</span
        >
        <div
          style="display: flex; padding: 10px; justify-content: space-between"
          v-if="course.responsibles"
        >
          <p style="font-size: 14px; font-weight: bold; color: #6b6b6b">
            {{ course.responsibles.name }}
          </p>
          <p>CPF: {{ course.responsibles.cpf }}</p>
          <p>Telefone: {{ course.responsibles.telefone }}</p>
          <p>Email: {{ course.responsibles.email }}</p>
        </div>
        <div v-else>
          <p>Responsável não disponível.</p>
        </div>
        <span
          style="
            display: flex;
            font-size: 16px;
            font-weight: bold;
            padding-left: 20px;
            border-bottom: 1px solid #cdcdcd;
            width: 100%;
          "
          >Fiador</span
        >
        <div
          style="display: flex; padding: 10px; justify-content: space-between"
          v-if="course.bondsmans"
        >
          <p style="font-size: 14px; font-weight: bold; color: #6b6b6b">
            {{ course.bondsmans.name }}
          </p>
          <p>CPF: {{ course.bondsmans.cpf }}</p>
          <p>Telefone: {{ course.bondsmans.telefone }}</p>
          <p>Email: {{ course.bondsmans.email }}</p>
        </div>
        <div v-else>
          <p>Fiador não disponível.</p>
        </div>
      </div>
      <div class="rowContainer" style="margin-bottom: 30px">
        <div>
          <div class="content-btn-fixed">
            <b-button
              style="visibility: hidden"
              class="btnsSave"
              @click="saveOrUpdateCourse"
              >{{ dataStudent.id ? "Atualizar" : "Salvar" }}
            </b-button>
            <b-button class="btnsSave" @click="saveOrUpdateCourse"
              >{{ dataStudent.id ? "Atualizar" : "Salvar" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
// import CourseService from "../../services/course";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
// import { ValidadeCourse } from "../../validators/course";
import { convertFileToBase64 } from "../../utils/convertFileToBase64";
import notImg from "../../assets/notImg.png";
import CourseService from "../../services/course";

export default {
  props: {
    clearAll: {
      type: Boolean,
    },
  },
  data() {
    return {
      dataStudent: {
        id: "",
        name: "",
        cpf: "",
        birth_date: "",
        user_id: "",
        created_at: "",
        updated_at: "",
        phone: "",
        cep: "",
        address: "",
        number: "",
        district: "",
        city: "",
        uf: "",
        rg: "",
        email: "",
        old_school: "",
        isSchoolPublic: 0,
        isStudentOfOmega: 0,
        isOldStudentOfOmega: 0,
        isResideForaVicosa: 0,
        courses: [],
        responsibles: [],
      },
      image: "",
      imageName: "",
      imgBase64: null,
      textLogo: "Click me",
      classImg: "logo_img",
      getCourse: false,
      spinGeneral: false,
      isInvalidInput: "",
      selectedRadio: "",
      notImg: notImg,
    };
  },

  methods: {
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_STUDENT",
    ]),
    clearInputs() {
      this.SET_DATA_SEARCH_FROM_STUDENT({});
    },

    saveOrUpdateCourse() {
      this.updateCourse();
    },

    async updateCourse() {
      try {
        await CourseService.updateStudents(
          this.dataStudent,
          this.dataStudent.id
        );

        this.$emit("getAllCourse");
        this.getCourse = !this.getCourse;
        this.SET_IS_SEARCH_REGISTERS({});
        this.clearInputs();
        this.$toast.open({
          message: "Aluno atualizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(message);
        if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);
      }
    },

    assingEditUser() {
      Object.assign(this.dataStudent, this.dataSearchStudent);
      this.dataStudent.cpf = this.dataSearchStudent.cpf;
    },

    openModals(idModal) {
      this.$bvModal.show(idModal);
    },
    formatDocuments(documents) {
      if (!documents) return "Documentos não informados";
      return Object.keys(documents)
        .filter((docName) => documents[docName])
        .join(", ");
    },
    async selectImage(e) {
      const base64 = await convertFileToBase64(e.target.files[0]);
      this.imageName = e.target.files[0].name;
      this.imgBase64 = base64;
      this.image = base64;

      this.classImg = "logo_img_not";
    },
  },
  mounted() {
    if (this.dataSearchStudent.id) {
      this.assingEditUser();
    }
  },
  computed: {
    ...mapState({
      dataSearchStudent: (state) => state.dataSearchStudent,
    }),
    formattedCourses() {
      return this.dataStudent?.studentCourse.map((course) => ({
        ...course,
        validDocuments: this.formatDocuments(
          course.documentsApproved?.documentsValids
        ),
      }));
    },
  },
  beforeDestroy() {
    this.clearInputs();
  },
};
</script>
<style scoped>
.form-control-sm {
  height: 28px;
  padding: 0.25rem 0.25rem;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 0.2rem;
}

.content-btn-fixed {
  width: 100%;
  padding: 0.7% 0px;
  left: 60px;
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #ffff;
  z-index: 10;
  box-shadow: -2px -2px 4px 0 rgba(0, 0, 0, 0.102);
}

.form-group {
  margin-bottom: 0.2rem;
}

span {
  font-weight: bold;
  cursor: context-menu;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconSelect {
  position: absolute;
  right: 0px !important;
  z-index: 10;
  background-color: rgb(213, 213, 213);
  color: whitesmoke;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: context-menu;
}

.contentImg {
  display: flex;
  width: 100%;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  padding: 20px 10px;
  margin-bottom: 10px;
  gap: 20px;
  position: relative;
}

.leftImg {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
}

.rightImg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  position: relative;
}

.image-container {
  width: 20%;
}

.input-container {
  width: 80%;
}

.imageCourse {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 7px !important;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 5px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.contentImg > div {
  display: flex;
}

.contentImg .logo {
  height: 135px;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border-radius: 7px;
  border: solid 1px rgb(223 223 223);
  color: #aaa;
  cursor: pointer;
  margin: 0;
}

.contentImg .logo:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.contentImg .logo__img {
  max-height: 120px;
  max-width: 200px;
}

.logo_img_not {
  height: 148px;
  width: 200px;
  max-height: 150px;
  max-width: 200px;
  cursor: pointer;
}

#input_file {
  display: none;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.imageCourse {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 7px !important;
}

.bcsCep {
  display: flex;
  height: 30px;
  position: absolute;
  right: 0px;
  font-size: 11px;
  z-index: 2;
  cursor: pointer;
  color: black;
  border-radius: 5px;
  border: none;
  background: #c3c3c3;
  align-items: center;
}

.validRed {
  font-size: 13px;
  color: red;
}

.user-label-ob {
  position: absolute;
  left: 40px;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}
.user-label-img {
  font-size: 11px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  margin-top: 0.3rem;
}

.course {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ddd;
  background: #f9f9f9;
  border-radius: 5px;
  width: 100%;
}

.contentCoursesStudent {
  display: flex;
  flex-direction: column;
  font-weight: 100 !important;
  padding: 10px;
}

.contentCoursesStudent span {
  font-weight: 100 !important;
  text-transform: capitalize;
}

.radio-input {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-evenly;
}

.cyberpunk-checkbox {
  appearance: none;
  width: 15px;
  height: 15px;
  border: 2px solid #0188c8;
  border-radius: 5px;
  background-color: transparent;
  display: inline-block;
  position: relative;
  margin-right: 10px;
  cursor: pointer;
}

.cyberpunk-checkbox:before {
  content: "";
  background-color: #0188c8;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 8px;
  height: 8px;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}

.cyberpunk-checkbox:checked:before {
  transform: translate(-50%, -50%) scale(1);
}

.cyberpunk-checkbox-label {
  font-size: 13px;
  color: #454545;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
.input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.validRed::before {
  color: blue;
}
.selectPlus {
  position: relative;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.selectPlusImg {
  position: relative;
  width: 23%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 8.9px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.fixedSelect3 {
  position: relative;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 40px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 600;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  display: flex;
  margin-bottom: 20px;
  margin-right: 20px;
  border-bottom: 1px solid rgb(230, 230, 230);
  justify-content: space-between;
}

.title span {
  font-weight: 600;
}

.requiredFields {
  font-size: 11px;
  color: red;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.rowContentImg {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 40px;
}

.rowObservation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 10px 0 5px 0;
}

.btnsContainer {
  gap: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 2rem;
}

.btnsSave {
  border-radius: 5px;
  background-color: #0188c8;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
}

.btnsSaveNeutral {
  border-radius: 5px;
  background-color: #d7d7d7;
  width: 165px;
  border: none;
  color: rgb(0, 0, 0);
  font-size: 12px;
  font-weight: 600;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 1rem 0 1rem;
}

.card {
  border: none !important;
}

@media screen and (max-width: 700px) {
  .rowContent {
    display: flex;
    width: 100%;
    padding: 5px 0 5px 0;
    justify-content: space-between;
    gap: 10px;
    flex-direction: column;
  }

  .contentImg {
    flex-direction: column;
  }

  .rightImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
    flex-direction: column;
  }

  .rowContentImg {
    display: flex;
    width: 100%;
    gap: 0px;
    flex-direction: column;
    align-items: center;
  }

  .borderInput {
    width: 100%;
  }

  .selectPlusImg {
    width: 100%;
  }

  .selectPlus {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 20px;
    align-items: center;
  }
}
</style>
